export default __webpack_public_path__ + "static/media/dots_small_light.f2c378eb.png";